import { MerchantCategoryRuleItem } from '@/pages/rule/utils/types'
import { EndTimeTypeEnum, BudgetFeeTypeFeEnum, StaffStatusEnum, BudgetFeeConfigTypeEnum } from '.'
import { IExcelConfig } from '../components/ExcelInput'
import { IExpiryConfigiFe } from '../components/ExpiryConfigFormItem'


/** 费用代码填写要求枚举 */
export type ExpenseCodeFillMode = 'NONE' | 'OPTIONAL' | 'REQUIRED'

/** 费用代码配置（前端表单） */
export interface FEExpenseCodeConfig {
  /** 是否开启下单填写（对应后端 switchOn） */
  enabled: boolean;
  /** 费用代码填写要求（对应后端 expenseMode） */
  mode: ExpenseCodeFillMode;
  remarkMode: ExpenseCodeFillMode;
}

/** 费用代码配置（提交/响应，字段与后端保持一致） */
export interface SubmitExpenseCodeConfig {
  /** 是否开启下单填写 */
  switchOn: boolean;
  /** 费用代码填写要求 */
  expenseMode: string;
  remarkMode: string;
}

/** 前端表单结构 */
export interface FEFormData {
  rulePackageName: string;
  budgetFeeType?: BudgetFeeTypeFeEnum;
  rulePackageDescription: string;
  /** 下发周期-有效期 */
  expiryConfig: IExpiryConfigiFe;

  /** 下发周期 */
  periodType?: string

  /** 预算金额(元) */
  budgetAmount?: string
  /** 是否使用Excel定义预算金额 */
  amountFrom?: BudgetFeeConfigTypeEnum
  /** Excel预算链接 */
  initExcelConfig: IExcelConfig;
  updateExcelConfig?: IExcelConfig;
  /** 适用服务 */
  availableServiceCodeList: string[];

  /** 限制品类 */
  disableCategoryCodeList: string[];

  /** 生效时间 */
  startTime: number;

  /** 结束时间 */
  endTime: {
    time?: number;

    /** 结束时间类型（1-自定义，2-长期有效） */
    type: EndTimeTypeEnum;
  };

  /** 余额批次 */
  batchNoList: {label:string, value:string}[]

  /** 适用人群 */
  assignInfo: {

    /** 是否分配全员 */
    assignAll: boolean;

    /** 分配员工ID列表 */
    assignStaffList: {label:string, value: string}[];

    /** 分配部门ID列表 */
    assignDepartmentList: {label:string, value: number}[];

    /** 分配分组ID列表 */
    assignGroupList: {label:string, value: number}[];
  };

  /** 适用状态 */
  staffStatus: StaffStatusEnum;

  /** 可用时段 */
  repastPeriodRule: RepastPeriodRule;

  /** 送餐地址 */
  deliveryAddressRule: DeliveryAddressRule;

  /** 自取地址 */
  pickupAddressRule: PickupAddressRule;
  shopLimitConfig: IShopLimitConfig;
  /** 费用代码配置 */
  expenseCodeConfig: FEExpenseCodeConfig;
}

export interface IShopLimitConfig {
  enable: boolean;
  shopList: {
    label:string,
    value: string;
    originValue: any;
  }[]
  brandList: {
    label:string,
    value: string;
    originValue: any;
  }[]
}

/** 提交表单数据 */
export interface SubmitRulePackage {

  /** 规则包名称（最多50字符） */
  rulePackageName: string;
  budgetFeeRule?: IBudgetFeeRule

  /** 规则包描述（最多200字符） */
  rulePackageDescription: string;

  /** 下发方式 */
  budgetFeeType: number
  userServiceRule: {availableServiceCodeList: string[]}

  /** 余额批次 */
  balanceBatchInfo: {batchNoList: string[]}

  /** 使用人群 */
  assignInfo: {

    /** 是否分配全员 */
    assignAll: boolean;

    /** 分配员工ID列表 */
    assignStaffIdList: string[];

    /** 分配部门ID列表 */
    assignDepartmentIdList: number[];

    /** 分配分组ID列表 */
    assignGroupIdList: number[];
  };

  /** 生效时间规则 */
  effectiveTimeRule: EffectiveTimeRule;

  /** 适用状态 */
  staffStatusRule: StaffStatusRule;

  /** 限制品类 */
  merchantCategoryRule: {
    disableCategoryCodeList: string[];
  }

  /** 可用时段 */
  repastPeriodRule: RepastPeriodRule;


  /** 收货地址规则 */
  deliveryAddressRule: DeliveryAddressRule;
  pickupAddressRule: PickupAddressRule;
  bannedShopRule: BannedShopRule;
  /** 禁用品牌规则 */
  bannedBrandRule: BannedBrandRule;
}

export interface RulePackageRes {

  /** 规则包名称（最多50字符） */
  rulePackageName: string;
  rulePackageId: number

  /** 下发方式 预算类型（2-余额批次，1预算津贴） */
  budgetFeeType: 2 | 1

  /** 规则包描述（最多200字符） */
  rulePackageDescription: string;

  /** 分配信息 */
  assignInfo: {

    /** 是否分配全员 */
    assignAll: boolean;

    /** 分配员工ID列表 */
    assignStaffList: {staffId:string, staffName:string}[];

    /** 分配部门ID列表 */
    assignDepartmentList: {departmentId:number, departmentName:string, departmentDisplayName?: string}[];

    /** 分配分组ID列表 */
    assignGroupList?: {groupId:number, groupName:string}[];
  };

  /** 生效时间规则 */
  effectiveTimeRule: EffectiveTimeRule;

  /** 员工状态规则 */
  staffStatusRule: StaffStatusRule;

  /** 商家品类规则 */
  merchantCategoryRule: MerchantCategoryRule;

  /** 用户服务规则 */
  userServiceRule: UserServiceRule;

  /** 用餐时段规则 */
  repastPeriodRule: RepastPeriodRule;

  /** 余额批次信息 */
  balanceBatchInfo?: {
    batchList: {batchNo: string, batchName:string}[]
  };

  /** 收货地址规则 */
  deliveryAddressRule: DeliveryAddressRule;
  /** 自取地址规则 */
  pickupAddressRule: PickupAddressRule;
  budgetFeeRule?: IBudgetFeeRule
  /** 禁用店铺规则 */
  bannedShopRule?: BannedShopRule;
  /** 禁用品牌规则 */
  bannedBrandRule?: BannedBrandRule;
}
interface BannedShopRule {
  /** 是否校验禁用店铺 */
  checkBannedShop?: boolean;
  /** 禁用店铺列表 */
  bannedShopList?: {
    /** 店铺id */
    shopId: string;
    /** 店铺名称 */
    shopName: string;
    /** 店铺地址 */
    shopAddress: string;
  }[];
}

interface BannedBrandRule {
  /** 是否校验禁用品牌 */
  checkBannedBrand?: boolean;
  /** 禁用品牌列表 */
  bannedBrandList?:  {
    /** 品牌id */
    brandId: string;
    /** 品牌名称 */
    brandName: string;
  }[];
}

export interface IBudgetFeeRule {
  periodType: number,
  budgetAmount: string,
  amountFrom?: number,
  initExcelS3Name?: string,
  initExcelName?: string,
  initExcelUrl?: string,
  updateExcelS3Name?:string,
  updateExcelName?: string,
  /** 结束时间延长周期类型 */
  expiryType?: number,
  /** 结束时间延长周期值 */
  expiryValue?: string,
  /** 费用代码配置（放在 budgetFeeRule 内传给后端） */
  expenseCodeConfig?: SubmitExpenseCodeConfig,
}


/** 生效时间规则 */
export interface EffectiveTimeRule {

  /** 开始时间 */
  startTime?: number;

  /** 结束时间 */
  endTime?: number;

  /** 结束时间类型（1-自定义，2-长期有效） */
  endTimeType: EndTimeTypeEnum;
}

/** 员工状态规则 */
export interface StaffStatusRule {

  /** 是否限制员工状态 */
  checkStaffStatus: boolean;

  /** 员工状态列表(1-离职，2-在职) */
  availableStaffStatusCodeList: number[];
}

/** 用户服务规则 */
export interface UserServiceRule {

  /** 可用服务编码列表 */
  availableServiceCodeList?: string[];
}

/** 用餐时段规则 */
export interface RepastPeriodRule {

  /** 是否限制用餐时段 */
  checkRepastPeriod: boolean;

  /** 用餐时段类型（1-自定义） */
  repastPeriodType: 1;

  /** 用餐时段列表 */
  repastPeriodList?: {

    /** 用餐日期类型（1-星期，2-工作日） */
    repastDateType: 1 | 2;

    /** 用餐时间类型（1-全天，2-特定时段） */
    repastTimeType: 1 | 2;

    /** 星期列表（1-7） */
    weekList?: number[];

    /** 工作日类型列表 */
    workdayTypeList: number[]

    /** 用餐时间列表 */
    repastTimeList: {

      /** 开始时间（HH:mm） */
      startTime: string;

      /** 结束时间（HH:mm） */
      endTime: string;
    }[];
  }[];


}


/** 收货地址规则 */
export interface DeliveryAddressRule {

  /** 是否限制收货地址 */
  checkDeliveryAddress: boolean;

  /** 收货地址列表 */
  deliveryAddressList: IDeliveryAddressItem[];
}


export interface PickupAddressRule {

  /** 是否限制收货地址 */
  checkPickupAddress: boolean;

  /** 收货地址列表 */
  pickupAddressList: IDeliveryAddressItem[];
}

/** 收货地址 */
export interface IDeliveryAddressItem {

  /** 具体地址 */
  address: string;

  /** 地址说明 */
  description: string;

  /** 纬度（浮点数字符串） */
  latitude?: string;

  /** 经度（浮点数字符串） */
  longitude?: string;

  /** 半径（米） */
  radius?: number;
}

/** 商家品类规则 */
export interface MerchantCategoryRule {

  /** 禁用品类编码列表 */
  disableCategoryList?: MerchantCategoryRuleItem[];
}


export enum RepastWorkDayEnum {
  WEEK = 1, // 星期
  WORK_DAY = 2 // 工作日
}

